import DetailStockFisik from "./DetailStockFisik";

export default DetailStockFisik;
